import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import HighZTooltip from './HighZTooltip';
import { RestrictedContentProps } from './types';

const RestrictedContent: React.FC<RestrictedContentProps> = ({
  children,
  isRestricted,
  tooltipMessage = 'Upgrade your plan to see this values',
  className = '',
}) => {
  if (!isRestricted) {
    return <>{children}</>;
  }

  const hasContent =
    React.Children.count(children) > 0 &&
    React.Children.toArray(children).some(child => (typeof child === 'string' ? child.trim() : true));

  const displayContent = <span>123</span>;

  return (
    <HighZTooltip content={tooltipMessage} position="right">
      <div className={`relative cursor-help ${className}`}>
        <div
          style={{
            filter: 'blur(4px)',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        >
          {displayContent}
        </div>
        <div
          className="absolute inset-0 flex items-center justify-center"
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(2px)',
          }}
        >
          <LockClosedIcon className="w-4 h-4 text-gray-400" />
        </div>
      </div>
    </HighZTooltip>
  );
};

export default RestrictedContent;
